/** Registre ordonné des 8 moteurs (ordre du hub). */
import type { GameEngine } from '@ordre-cache/shared';
import { RESEAU } from './reseau';
import { MIROIRS } from './miroirs';
import { VITRAIL } from './vitrail';
import { DUO } from './duo';
import { LUMIERES } from './lumieres';
import { ROTOR } from './rotor';
import { FILAMENTS } from './filaments';
import { PONTS } from './ponts';

export const GAMES: GameEngine[] = [
  RESEAU,
  MIROIRS,
  VITRAIL,
  DUO,
  LUMIERES,
  ROTOR,
  FILAMENTS,
  PONTS,
];

export { RESEAU, MIROIRS, VITRAIL, DUO, LUMIERES, ROTOR, FILAMENTS, PONTS };
